/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomOrder = {
    properties: {
        rooms: {
    type: 'array',
    contains: {
        type: 'Room',
    },
    isRequired: true,
},
    },
};